import { render, staticRenderFns } from "./FoodPurchaseOrder.vue?vue&type=template&id=71c053cd&"
import script from "./FoodPurchaseOrder.vue?vue&type=script&lang=js&"
export * from "./FoodPurchaseOrder.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports